module.exports = __webpack_public_path__ + "img/api-integrations2.6599bc25.jpg";